// extracted by mini-css-extract-plugin
export default {"component":"NavigationTitle__component--lc-_5qdk","title":"NavigationTitle__title--lc-uZkaR","all":"NavigationTitle__all--lc-F5nAx","arrow":"NavigationTitle__arrow--lc-uuSwR"};